module.exports = __webpack_public_path__ + "/static/assets/f9f07be8ec98644e89b6441812882c6e.png";